import {
  CONTEXTUAL_getInstance2bsxm25kydylq as CONTEXTUAL_getInstance,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  LIST_getInstance2xmlsct1exo3w as LIST_getInstance,
  MAP_getInstance173r3f2itu405 as MAP_getInstance,
  ENUMlmq49cvwy4ow as ENUM,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ClassDiscriminatorMode_NONE_getInstancen9ln5ytvklfv as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkKind($this, descriptor, actualClass) {
  var kind = descriptor.d1p();
  var tmp;
  if (kind instanceof PolymorphicKind()) {
    tmp = true;
  } else {
    tmp = equals(kind, CONTEXTUAL_getInstance());
  }
  if (tmp) {
    throw IllegalArgumentException().o2('Serializer for ' + actualClass.j1() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
  }
  if ($this.m2s_1)
    return Unit_instance;
  if (!$this.n2s_1)
    return Unit_instance;
  var tmp_0;
  var tmp_1;
  if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
    tmp_1 = true;
  } else {
    tmp_1 = kind instanceof PrimitiveKind();
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    tmp_0 = kind instanceof ENUM();
  }
  if (tmp_0) {
    throw IllegalArgumentException().o2('Serializer for ' + actualClass.j1() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
  }
}
var JsonSerializersModuleValidatorClass;
function JsonSerializersModuleValidator() {
  if (JsonSerializersModuleValidatorClass === VOID) {
    class $ {
      constructor(configuration) {
        this.m2s_1 = configuration.o2n_1;
        this.n2s_1 = !configuration.w2n_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      }
      w27(kClass, provider) {
      }
      z27(baseClass, actualClass, actualSerializer) {
        var descriptor = actualSerializer.h1m();
        checkKind(this, descriptor, actualClass);
      }
      a28(baseClass, defaultSerializerProvider) {
      }
      b28(baseClass, defaultDeserializerProvider) {
      }
    }
    protoOf($).y27 = contextual;
    initMetadataForClass($, 'JsonSerializersModuleValidator', VOID, VOID, [SerializersModuleCollector()]);
    JsonSerializersModuleValidatorClass = $;
  }
  return JsonSerializersModuleValidatorClass;
}
//region block: exports
export {
  JsonSerializersModuleValidator as JsonSerializersModuleValidator1v682i122jgoa,
};
//endregion

//# sourceMappingURL=JsonSerializersModuleValidator.mjs.map
